module.exports = __webpack_public_path__ + "img/832353834615D80F9B7221FB2FBCB9F0.83235383.png";